import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Typography,
  useMediaQuery,
  List,
  ListItem,
} from "@mui/material";

import "./faqs.css";

import Ah from "./Assets/Ah.png";
import Bounce from "react-reveal/Bounce";

let AccordionData = [
  {
    summary: "WHAT IS AN NFT?",
    details:
      "An NFT is created, or “minted” from digital objects that represent both tangible and intangible items. In this case, Soulmapes NFT represents exclusive membership in a community centered around love.",
  },
  {
    summary: "WHY JOIN SOULMAPES?",
    details:
      "As the world’s first NFT focused towards couples, Soulmapes is an exclusive community centered around love. Created to uplift one another and share date night ideas, romantic memories, relationship advice and much more.",
  },
  {
    summary: "HOW DOES SOULMAPES WORK?",
    multiple: true,
    details:
      "Soulmapes is a one-of-a-kind NFT where you mint the NFT in pairs. It is created to share the love of NFT with your soulmate. Each pair of NFT is linked to a unique digital Lovelock.  Currently, we’re geared to launch in March.",
    details2:
      "After mint, we’ll start to create digital Lovelocks on the Blockchain, where you and your significant other can write (secret) messages to each other and put it on the Lovelock. The Lovelock represents your love and commitment towards each other, staying on the blockchain for all of eternity for future generations to see.",
    details3:
      "Inspired by the famous Love Lock Bridge in Paris “Pont des Arts”, we’ll be building the world’s first “Bridge Of Love” in the metaverse. A world’s first!",
  },
  {
    summary: "WHAT IS THE TOTAL SUPPLY?",
    multiple: true,
    details:
      "There are a total of 20,000 NFTs in the collection; 10,000 primary and 10,000 supplementary NFT’s. Primary and supplementary Soulmapes are exact digital copies of each other!",
    details2:
      "Primary NFTs will be available during Minting, or exclusive airdrop events Supplementary NFTs can be claimed by the primary NFT holder, or be directly gifted to their significant other! [**additional gas fees may apply].",
    details3:
      "Primary and supplementary NFT pairs are linked together by a unique Digital Lovelock that exists on the blockchain via custom smart contract, known as a Lovelock ID.",
  },
  {
    summary: "HOW DO I PURCHASE A SOULMAPES NFT?",
    //List
    details: (
      <>
        {" "}
        <Box>
          We haven’t launched our presale yet, stay tuned for more information!
        </Box>{" "}
        <Box my="20px"> How to buy </Box>{" "}
        <Box mb="10px">
          {" "}
          Here are the steps on what you need to do to get your Soulmapes NFT.
        </Box>{" "}
        <Box>
          <List>
            <ListItem>
              1. Download the metamask.io extension on your browser
            </ListItem>
            <ListItem>
              2. Purchase Ethereum from various exchanges, such as Coinbase or
              Binance
            </ListItem>
            <ListItem>
              3. Send Ethereum from this exchange to your MetaMask wallet
            </ListItem>
            <ListItem>
              4. On launch day, open the Soulmapes website and select the number
              of NFTs you wish to mint
            </ListItem>
            <ListItem>
              5. Click “MINT” button, Metamask will popup asking for connection
            </ListItem>
            <ListItem>
              6. Confirm the transaction and any associated fees
            </ListItem>
            <ListItem>
              7. Once you have made your purchase, your NFTs will appear in your
              wallet and on OpenSea
            </ListItem>
          </List>
        </Box>{" "}
      </>
    ),
  },
];

const Faqs = () => {
  const hide = useMediaQuery("(max-width:600px)");
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  let check = true;
  return (
    <div style={{ margin: "180px 0px 40px 0px" }}>
      <Box bgcolor="red" sx={{ position: "relative" }}>
        <img
          alt=""
          className="zoom-in-out-box"
          style={{
            position: "absolute",
            left: "-90px",
            top: "20px",
            zIndex: "9",
            width: "150px",
          }}
          src={Ah}
        />
      </Box>
      <Box sx={{ textAlign: "center" }}>
        <Typography
          fontSize={{ xs: "26px", sm: "32px", md: "55px" }}
          sx={{
            color: "white",
            fontWeight: "700",
            fontFamily: "'Baloo Bhai 2', cursive",
            textShadow: "0px 0px 20px #FFFFFF",
          }}
          mb={8}
        >
          FAQ'S
        </Typography>

        {AccordionData.map((value, index, array) => {
          return (
            <Box sx={{ margin: "auto", width: "80%" }}>
              {/* <Bounce left> */}
              <Accordion
                expanded={expanded === `panel${index + 1}`}
                onChange={handleChange(`panel${index + 1}`)}
                sx={{
                  marginTop: "20px",
                  marginBottom: "20px",
                  background: "transparent",
                  boxShadow: "none",
                }}
              >
                <AccordionSummary
                  aria-controls={`panel${index + 1}bh-content`}
                  id={`panel${index + 1}bh-header`}
                  className="borderRad"
                  expandIcon={
                    <i
                      style={{ color: "#511D66" }}
                      class="fa-solid fa-plus"
                    ></i>
                  }
                  // aria-controls="panel1a-content"
                  // id="panel1a-header"
                  sx={{ padding: "15px 20px", background: "#F3ADB4" }}
                >
                  <Box
                    textAlign="center"
                    fontSize={check ? "18px" : "26px"}
                    lineHeight={check ? "25px" : "40px"}
                    fontFamily="Josefin Sans"
                    sx={{
                      color: "#511D66",
                      fontWeight: "bold",
                      fontFamily: "'Baloo Bhai 2', cursive",
                    }}
                  >
                    {value.summary}
                  </Box>
                </AccordionSummary>
                <AccordionDetails
                  sx={{ background: "#CF1B52", padding: "60px 30px" }}
                >
                  <Box
                    textAlign="left"
                    fontSize={check ? "16px" : "20px"}
                    lineHeight={check ? "20px" : "30px"}
                    sx={{
                      color: "white",
                      fontFamily: "'Baloo Bhai 2', cursive",
                    }}
                  >
                    {value.details}
                    {value.multiple ? (
                      <p>
                        <br />
                        <p>{value.details2}</p>
                        <br />
                        <p>{value.details3}</p>
                      </p>
                    ) : (
                      ""
                    )}
                  </Box>
                </AccordionDetails>
              </Accordion>
              {/* </Bounce> */}
            </Box>
          );
        })}
      </Box>

      {hide ? (
        <></>
      ) : (
        <>
          <Box bgcolor="red" sx={{ position: "relative" }}>
            <img
              alt=""
              className="zoom-in-out-box"
              style={{
                position: "absolute",
                right: "-50px",
                top: "-100px",
                zIndex: "9",
                width: "100px",
              }}
              src={Ah}
            />
          </Box>
        </>
      )}
    </div>
  );
};

export default Faqs;
